function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Iarea = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_45769_43406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 9.68793C18.0907 9.68793 18.4887 9.28997 18.4887 8.79905C18.4887 8.30813 18.0907 7.91016 17.5998 7.91016C17.1089 7.91016 16.7109 8.30813 16.7109 8.79905C16.7109 9.28997 17.1089 9.68793 17.5998 9.68793Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37717 0.800781C2.84384 0.800781 2.48828 1.15634 2.48828 1.68967V15.9119C2.48828 16.4452 2.84384 16.8008 3.37717 16.8008H17.5994C18.1327 16.8008 18.4883 16.4452 18.4883 15.9119C18.4883 15.3786 18.1327 15.023 17.5994 15.023H4.26606V1.68967C4.26606 1.24523 3.82161 0.800781 3.37717 0.800781Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 6.13325C18.0907 6.13325 18.4887 5.73528 18.4887 5.24436C18.4887 4.75344 18.0907 4.35547 17.5998 4.35547C17.1089 4.35547 16.7109 4.75344 16.7109 5.24436C16.7109 5.73528 17.1089 6.13325 17.5998 6.13325Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4885 2.57856C10.9794 2.57856 11.3774 2.18059 11.3774 1.68967C11.3774 1.19875 10.9794 0.800781 10.4885 0.800781C9.99758 0.800781 9.59961 1.19875 9.59961 1.68967C9.59961 2.18059 9.99758 2.57856 10.4885 2.57856Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0451 2.57856C14.5361 2.57856 14.934 2.18059 14.934 1.68967C14.934 1.19875 14.5361 0.800781 14.0451 0.800781C13.5542 0.800781 13.1562 1.19875 13.1562 1.68967C13.1562 2.18059 13.5542 2.57856 14.0451 2.57856Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 2.57856C18.0907 2.57856 18.4887 2.18059 18.4887 1.68967C18.4887 1.19875 18.0907 0.800781 17.5998 0.800781C17.1089 0.800781 16.7109 1.19875 16.7109 1.68967C16.7109 2.18059 17.1089 2.57856 17.5998 2.57856Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2226 15.2897L16.0004 13.0674C15.6448 12.7119 15.1115 12.7119 14.7559 13.0674C14.4004 13.423 14.4004 13.9563 14.7559 14.3119L15.4671 15.023V16.8008L14.6671 17.5119C14.3115 17.8674 14.3115 18.4008 14.6671 18.7563C15.0226 19.1119 15.5559 19.1119 15.9115 18.7563L18.1337 16.5341C18.2226 16.4452 18.3115 16.3563 18.3115 16.2674C18.4004 16.0897 18.4004 15.823 18.3115 15.5563C18.3115 15.4674 18.3115 15.3786 18.2226 15.2897Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26662 3.823L4.88885 4.53411C5.2444 4.88967 5.77773 4.88967 6.13329 4.53411C6.48885 4.17856 6.48885 3.64523 6.13329 3.28967L3.99996 1.06745C3.6444 0.711892 3.11107 0.711892 2.75551 1.06745L0.444401 3.28967C0.0888455 3.64523 0.0888455 4.17856 0.444401 4.53411C0.799957 4.88967 1.33329 4.88967 1.68885 4.53411L2.39996 3.823H4.26662Z",
    fill: "#495057"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45769_43406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "18.6667",
    height: "20",
    fill: "white"
  })))));
});